<template>
  <div>
    <Clock
      v-show="contentAppointmentLobby.settings.showTimmer"
      class="px-5 pb-5"
      :initDate="new Date($ocularMoment.timeZoneDate(date.initDate))"
      :startDate="new Date($ocularMoment.timeZoneDate(date.startDate))"
      :waitingDate="new Date($ocularMoment.timeZoneDate(date.waitingTime))"
      :endDate="new Date($ocularMoment.timeZoneDate(date.endDate))"
      :scheduledEventState="date.state"
      :code="date.code"
      @verifyLink="verifyLink"
      @clearRoom="clearRoom"
    />
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        v-if="contentAppointmentLobby.settings.showWidgetData"
        lg="8"
        md="12"
        cols="12"
      >
        <div
          class="d-flex px-5"
          :class="!contentAppointmentLobby.widgetData.description ? 'align-center' : ''"
        >
          <div
            v-if="!$route.query.widgetMode && contentAppointmentLobby.widgetData.image.show"
          >
            <v-avatar
              v-if="contentAppointmentLobby.widgetData.image.url"
              size="60"
              class="mr-5"
            >
              <v-img :src="contentAppointmentLobby.widgetData.image.url"></v-img>
            </v-avatar>
          </div>
          <div>
            <div
              v-if="contentAppointmentLobby.widgetData.title"
              style="color: #555"
              class="font-weight-bold"
              v-html="contentAppointmentLobby.widgetData.title"
            >
            </div>
            <div
              v-if="contentAppointmentLobby.widgetData.description"
              v-html="contentAppointmentLobby.widgetData.description"
              class="text--secondary"
            ></div>
          </div>
        </div>
      </v-col>
      <v-col
        v-show="contentAppointmentLobby.settings.showRoom"
        lg="8"
        md="8"
        cols="12"
      >
        <div class="mx-5" v-if="session && session.tokboxId && date.code !== 1 && (date.state.id === 1 || date.state.id === 5)">
          <Lobby
            :session="session"
            :organization="organization"
            :settings="contentAppointmentLobby.room"
          />
        </div>
      </v-col>
      <v-col
        v-if="contentAppointmentLobby.settings.showStateData"
        lg="8"
        md="12"
        cols="12"
        class="order-first order-md-last"
      >
        <v-sheet
          class="d-flex align-center justify-center px-5"
          elevation="0"
          rounded
        >
          <div class="mr-4">
            <Icon
              :size="24"
              :color="$vuetify.theme.themes.light.success"
              :icon="'information-outline'"
              class="mt-1"
            />
          </div>
          <div v-if="date.state.id === 1 || date.state.id === 5">
            {{ session && session.state.id === 3 ? $t('sessionLink.attendedCall') : $t(`sessionLink.messages.${date.message}`) }}
          </div>
          <div v-else>
            {{ $t('sessionLink.eventState') }} <b>{{ $t(`sessionLink.states.${date.state.name}`) }}</b>
          </div>
        </v-sheet>
        <div
          v-if="$route.query.widgetMode"
          class="text-center px-5 mt-2"
        >
          <Confirm
            ref="confirm"
            :title="$t('systemBar.confirmModal.title')"
            :detail="$t('systemBar.confirmModal.detail')"
            :action="$t('systemBar.confirmModal.action')"
            @confirmHandler="leave"
          />
          <v-btn
            elevation="0"
            outlined
            color="primary"
            class="text-none px-5"
            rounded
            @click="$refs.confirm.toggleConfirm()"
          >
            {{ $t('systemBar.exit') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row
      justify="center"
      align="center"
      class="mt-4"
    >
      <v-col
        v-if="contentAppointmentLobby.settings.showCustomerData"
        lg="4"
        class="order-last order-md-first"
      >
        <div class="mx-5">
          <Customer
            :customer="date.customer"
          />
        </div>
      </v-col>
      <v-col lg="4">
        <v-card class="px-5" elevation="0" rounded="xl">
          <div
            v-if="contentAppointmentLobby.settings.showCammerData"
            class="d-flex align-center mb-1"
          >
            <div
              v-if="session.agent.profileImage"
              class="mr-3"
            >
              <v-avatar
                size="50"
                class="border"
              >
                <v-img
                  :src="session.agent.profileImage"
                  alt="John"
                ></v-img>
              </v-avatar>
            </div>
            <div>
              <div
                class="caption text--secondary"
                v-html="contentAppointmentLobby.agent.title"
              >
              </div>
              <div style="line-height: 1">
                {{ session.agent.name }}
              </div>
              <small class="text--secondary">
                {{ session.agent.specialty }}
              </small>
            </div>
          </div>
          <v-list v-if="contentAppointmentLobby.settings.showEventData">
            <template>
              <v-list-item
                v-if="session"
                class="px-0"
              >
                <div class="mr-4">
                  <Icon
                    :size="24"
                    color="primary"
                    :icon="'timeline-text'"
                  />
                </div>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('sessionLink.attentionInfo.attention') }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ session.category }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="px-0">
                <div class="mr-4">
                  <Icon
                    :size="24"
                    color="primary"
                    :icon="'calendar-clock'"
                  />
                </div>
                <v-list-item-content>
                  <v-list-item-title>
                    {{$t('sessionLink.attentionInfo.eventDate')}}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $ocularMoment.timeZoneDate(date.initDate) | moment('DD/MM/YYYY') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="px-0">
                <div class="mr-4">
                  <Icon
                    :size="24"
                    color="primary"
                    :icon="'timeline-clock-outline'"
                  />
                </div>

                <v-list-item-content>
                  <v-list-item-title>
                    {{$t('sessionLink.attentionInfo.initDate')}}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $ocularMoment.timeZoneDate(date.initDate) | moment('h:mm a') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="px-0">
                <div class="mr-4">
                  <Icon
                    :size="24"
                    color="primary"
                    :icon="'timeline-clock-outline'"
                  />
                </div>

                <v-list-item-content>
                  <v-list-item-title>
                    {{$t('sessionLink.attentionInfo.startDate')}}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $ocularMoment.timeZoneDate(date.startDate) | moment('h:mm a') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="px-0">
                <div class="mr-4">
                  <Icon
                    :size="24"
                    color="primary"
                    :icon="'timeline-clock-outline'"
                  />
                </div>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('sessionLink.attentionInfo.endDate') }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $ocularMoment.timeZoneDate(date.endDate) | moment('h:mm a') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <div
      v-if="tokenGuest"
      class="text-center mt-5 px-5"
    >
      <h5 class="font-weight-regular mx-auto text--secondary" style="max-width: 500px">
        <i18n path="sessionLink.cancel">
          <a
            :href="`${calendarAppUrl}/scheduled-event-guest?tokenGuest=${tokenGuest}`"
            rel="noopener noreferrer"
          >
            {{ $t('sessionLink.here') }}
          </a>
        </i18n>
      </h5>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

require('@/plugins/OcularMoment')

@Component({
  components: {
    Clock: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/Clock.vue'),
    Lobby: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/Lobby.vue'),
    Customer: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/Customer.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    Confirm: () => import(/* webpackPrefetch: true */ '@/components/Confirm.vue')
  },
  props: {
    sessionLink: {
      type: Object,
      default: null
    },
    customMessage: {
      type: Object,
      default: null
    },
    calendarAppUrl: {
      type: String,
      default: process.env.VUE_APP_CALENDAR_APP_URL
    }
  },
  computed: {
    organization () {
      return this.sessionLink.organization
    },
    session () {
      return this.sessionLink.session
    },
    date () {
      return this.sessionLink.date
    },
    contentAppointmentLobby() {
      const contentAppointmentLobbyData = this.sessionLink.contentAppointmentLobby.data

      const defaultData = {
        settings: {
          showWidgetData: contentAppointmentLobbyData?.settings?.showWidgetData ?? true,
          showStateData: contentAppointmentLobbyData?.settings?.showStateData ?? true,
          showCustomerData: contentAppointmentLobbyData?.settings?.showCustomerData ?? true,
          showCammerData: contentAppointmentLobbyData?.settings?.showCammerData ?? true,
          showEventData: contentAppointmentLobbyData?.settings?.showEventData ?? true,
          showTimmer: contentAppointmentLobbyData?.settings?.showTimmer ?? true,
          showImageAvatar: contentAppointmentLobbyData?.settings?.showImageAvatar ?? true,
          showRoom: contentAppointmentLobbyData?.settings?.showRoom ?? true
        },
        widgetData: {
          title: contentAppointmentLobbyData?.widgetData?.title ?? this.organization.name,
          description: contentAppointmentLobbyData?.widgetData?.description ?? this.organization.message,
          image: {
            url: contentAppointmentLobbyData?.widgetData?.image?.url ?? this.organization.brand,
            show: contentAppointmentLobbyData?.widgetData?.image?.show ?? true
          }
        },
        room: {
          noCammer:{
            message1: contentAppointmentLobbyData?.room?.noCammer?.message1 ?? this.$t('sessionLink.lobby.noCammer.message1'),
            message2: contentAppointmentLobbyData?.room?.noCammer?.message2 ?? this.$t('sessionLink.lobby.noCammer.message2')
          },
          cammerWaiting:{
            message1: contentAppointmentLobbyData?.room?.cammerWaiting?.message1 ?? this.$t('sessionLink.lobby.cammerWaiting.message1'),
          },
          icon: {
            url: contentAppointmentLobbyData?.room?.icon?.url ?? 'account-circle-outline',
            show: contentAppointmentLobbyData?.room?.icon?.show ?? true
          }
        },
        agent: {
          title: contentAppointmentLobbyData?.agent?.title ?? 'Cammer'
        }
      }

      return defaultData
    }
  }
})
export default class Detail extends Vue {
  data () {
    return {
      tokenGuest: null,
      messageCustom: null
    }
  }

  mounted () {
    this.getGuestToken()
  }

  verifyLink () {
    this.$emit('verifyLink')
  }

  clearRoom () {
    console.log('clearRoom')
  }

  leave () {
    if (this.$organization.hideOnFinish()) {
      this.$widget.hide()
    } else {
      this.$widget.toggle(false)
    }

    setTimeout(async () => {
      this.$router.replace({ path: '/' })
    }, 500)
  }

  getGuestToken () {
    const params = new URLSearchParams(location.search)
    const tokenGuest = params.get('tokenGuest') ? params.get('tokenGuest') : null

    history.pushState({}, null, `${location.origin}${location.pathname}`)

    this.tokenGuest = tokenGuest
  }
}
</script>
